<template>
  <div>
    <div>
      <div class="scroll-table">
        <vue-seamless-scroll class="scroll-table-body" v-if="listData.length>0" :data="listData" :class-option="defaultOption">
          <ul class="scroll-ul">
            <li v-for="(item,index) in listData" :key="index">
<!--              <span>{{item.nickName | nameencry}}</span>-->
<!--              <span>累计捐赠{{item.sumAmount | sumFormat}}本</span>-->
              {{item.nickName }}累计捐赠{{item.sumAmount | sumFormat}}本
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "seamscroll",
  components:{
    vueSeamlessScroll
  },
  props:{
    listData:{
      type:Array
    }
  },
  data() {
    // 这里存放数据
    return {
      // 数字滚动
      startVal: this.$store.state.count,
      endVal: this.$store.getters.doneDoCount,
      // 无限滚动
      // listData: [
      //   {name: '张三累计捐赠3750元'},
      //   {name: '李四累计捐赠3750元'},
      //   {name: '王五累计捐赠3750元'},
      //   {name: '孙三累计捐赠3750元'},
      //   {name: '张钱三累计捐赠3750元'},
      //   {name: '立冬三累计捐赠3750元'},
      //   {name: '东方三累计捐赠3750元'},
      // ],
    }
  },
  // 监听属性 类似于data概念
  computed: {
    defaultOption () {
      return {
        step: 0.1,  // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }

  },
  methods: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // for(let i = 0 ; i < 15 ; i++){
    //   let j = {
    //     title:'无缝滚动第几条啊啊啊-'+i,
    //     time: '2020-04-10'
    //   }
    //   this.listData.push(j)
    // }
  }
}
</script>

<style scoped lang="scss">
   // 无限滚动
 .scroll-table {
   width: 400px;
   height: 150px;
   color:#A471AA;
   font-size:30px;
   box-sizing: border-box;
   padding-left: 40px;
   .scroll-table-body {
     height: calc(100% - 5px);
     overflow: hidden;
     ul {
       list-style: none;
       li {
         //height: 60px;
         margin-top: 10px;
         span {
           display: inline-block;
           padding-bottom: 10px;
           font-size:28px;
         }
       }
     }
   }
 }

</style>
